import { Pipe, PipeTransform, inject } from '@angular/core';
import { QuantityUnitProviderService } from '../providers/quantity-unit-provider.service';
import { Observable } from 'rxjs';
import { QuantityUnit } from '../enums/quantity-unit';

@Pipe({
  name: 'quantityUnit',
  standalone: true,
})
export class QuantityUnitPipe implements PipeTransform {
  private readonly provider = inject(QuantityUnitProviderService);

  public transform(unit: QuantityUnit): Observable<string> {
    return this.provider.label(unit);
  }
}
